import {MarkerFeatures} from "@ui/leafletCustom/types/marker";
import {
    CustomPropertyPointMarkerSingleVoyage,
    IPointGroupClusterItemSingleVoyage
} from "@containers/singleVoyage/containers/points/cluster/types";
import {TYPE_CUSTOM_PROPERTY_POINT_MARKER_SINGLE_VOYAGE} from "@containers/singleVoyage/containers/points/constants";

export const getPointsByMarkersCustomPropertySingleVoyage = (children: MarkerFeatures<CustomPropertyPointMarkerSingleVoyage>[]): IPointGroupClusterItemSingleVoyage[] => {
    if (!children?.length) {
        return []
    }
    const res: IPointGroupClusterItemSingleVoyage[] = []

    children.forEach((marker) => {
        if (marker?.options?.customProperty?.type === TYPE_CUSTOM_PROPERTY_POINT_MARKER_SINGLE_VOYAGE) {
            res.push(marker.options.customProperty)
        }
    })
    return res;
}